import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// eslint-disable-next-line
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/Global.module.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
